<div class="event-mentions" *ngIf="!loading && !error && !noData">
  <div class="event-mentions__header">
    <span class="event-mentions__header-title">Event mentions</span>
    <span class="event-mentions__header-volume">Volume</span>
    <span class="event-mentions__header-change">Change</span>
  </div>

  <div class="event-mentions__list">
    <div
      class="event-mentions__row"
      *ngFor="let event of events; let i = index"
    >
      <div class="event-mentions__name">
        <span class="event-mentions__index">{{ i + 1 }}.</span>
        <span class="event-mentions__label">{{ event.name }}</span>
      </div>
      <span class="event-mentions__volume">{{ event.contrib_amount }}</span>
      <div class="event-mentions__change" *ngIf="hasDelta(event)">
        <span
          class="event-mentions__badge"
          [class.up]="isDeltaPositive(event)"
          [class.down]="!isDeltaPositive(event)"
        >
          <mat-icon>{{
            isDeltaPositive(event) ? 'arrow_upward' : 'arrow_downward'
          }}</mat-icon>
        </span>
        <span
          class="event-mentions__delta"
          [class.up]="isDeltaPositive(event)"
          [class.down]="!isDeltaPositive(event)"
        >
          {{ getAbsDelta(event) }}
        </span>
      </div>
      <span class="event-mentions__change--empty" *ngIf="!hasDelta(event)"
        >-</span
      >
    </div>
  </div>
</div>

<div class="event-mentions event-mentions--center" *ngIf="loading">
  <mat-spinner [diameter]="36"></mat-spinner>
</div>

<div class="event-mentions event-mentions--center" *ngIf="error">
  <span class="event-mentions__message">Failed to load events</span>
</div>

<div
  class="event-mentions event-mentions--center"
  *ngIf="noData && !loading && !error"
>
  <span class="event-mentions__message">No event data available</span>
</div>
